import React, { useContext, useCallback, useMemo } from 'react';
import { hideSlideOutPanel, modeUIContext } from '@moderepo/mode-ui-state';
import { SlideOutComp } from '@moderepo/mode-app-components';
import { DeviceRegistrationWizardContainer } from '.';
import { DeviceRegistrationWizardSettings } from '../../../utils/ritzUIExtensionUtils';



interface DeviceRegistrationWizardSlideOutContainerProps {
    readonly projectId: number;

    // Optional deviceId. If this is undefined, it means to use the wizard to CREATE a new device. If this is provided, it means
    // to use the wizard to EDIT an existing device
    readonly deviceId?: number | undefined;

    readonly preselectedHomeId?: number | undefined;
    readonly deviceRegistrationWizardSettings: DeviceRegistrationWizardSettings;
}


export const DeviceRegistrationWizardSlideOutContainer = (props: DeviceRegistrationWizardSlideOutContainerProps) => {
    const { projectId } = props;
    const { dispatch:uiDispatch } = useContext(modeUIContext);



    /**
     * Unselect the selected KV pair and update the URL
     */
    const closeWizard = useCallback(() => {
        uiDispatch(hideSlideOutPanel());
    }, [uiDispatch]);



    /**
     * Handler for the onCancelEdit and onFinishEdit event from DeviceRegistrationWizardContainer
     */
    const onRegisterDeviceDone = useCallback(() => {
        closeWizard();
    }, [closeWizard]);



    const slideOutCompContent = useMemo(() => {
        return (
            <DeviceRegistrationWizardContainer
                className="transparent"
                projectId={projectId}
                deviceId={props.deviceId}
                preselectedHomeId={props.preselectedHomeId}
                onCancelRegistration={onRegisterDeviceDone}
                onFinishRegistration={onRegisterDeviceDone}
                deviceRegistrationWizardSettings={props.deviceRegistrationWizardSettings}
            />
        );
    }, [onRegisterDeviceDone, projectId, props.deviceRegistrationWizardSettings, props.deviceId, props.preselectedHomeId]);


    return (
        <SlideOutComp
            compContent={slideOutCompContent}
            closable={false}
            onCloseButtonClicked={closeWizard}
            contentContainerProps={{
                className: 'slide-out-comp-container',
            }}
        />
    );
};
